<template>
  <v-app class="nmg-app">
    <v-content>
          <v-dialog
      v-model="iOSPWAInstall"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Add to home screen</v-card-title>

        <v-card-text>
          Install Charity app on your iPhone.</br>
          <v-img style="display: inline-block;" width="19px" height="27px" :src="require('@/assets/iospwa.png')" />
          Just tap and then add to homescreen.
</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="iOSPWAInstallSkip"
          >
            Not now
          </v-btn>

          <!--<v-btn
            color="green darken-1"
            flat="flat"
            @click="iOSPWAInstall = false"
          >
            Agree
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
 
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios';
  export default {
    name: 'App',
    components: {},
    data () {
      return {
        iOSPWAInstall: false,
      }
    },
    methods: {
      iOSPWAInstallSkip: function() {
        localStorage.setItem('iOSPWAInstallSkip', 1);
        this.iOSPWAInstall = false;
      },
    },
  created() {
    
    const th = this;
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
      }
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
      const iOSPWAInstallSkip = localStorage.getItem('iOSPWAInstallSkip');
    if (isIos() && !isInStandaloneMode() && iOSPWAInstallSkip != 1) {
        this.iOSPWAInstall = true;
    }
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        const error = err.response;
        if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
        //  th.$store.dispatch('authentication/logout')
        }
        throw err;
      });
    });
  }
  }

</script>

<style scoped>
  @import "assets/fonts/fonts.css";
  @import "assets/css/app.css";

  .nmg-app {
    font-family: 'Calibri';
  }
</style>




